import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { LoaderService } from 'src/app/loader.service';
import { Button, Pagination, Table, TableData, TableDataTypes } from 'src/app/shared/types';
import { BulkPayArrayFields, BulkPayService } from '../bulkpay.service';
import * as moment from 'moment';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BULK_PAY_HISTORY } from 'src/app/routes';
import Utils from 'src/app/utils/utils';
var BulkPayHistoryComponent = /** @class */ (function () {
    function BulkPayHistoryComponent(bulkPayService, loader, alertService, currentRoute, router) {
        this.bulkPayService = bulkPayService;
        this.loader = loader;
        this.alertService = alertService;
        this.currentRoute = currentRoute;
        this.router = router;
        this.table = new Table({
            pagination: new Pagination(0, 10, 100, [5, 10, 15, 20]),
            headers: {
                createdAt: 'Date',
                createdBy: 'Initiated By',
                totalTransactions: 'Number of captains',
                totalAmount: 'Total Amount',
                subTransactionType: 'Sub Transaction',
                status: 'Status',
                result: 'Download result',
            },
            data: []
        });
        this.sortableColumns = ["createdAt"];
        this.historyQuery = {
            limit: 10,
            offset: 0,
            sortBy: "createdAt",
            sortOrder: -1,
            subTransactionType: [],
            from: undefined,
            to: undefined,
        };
        this.showFilters = false;
        this.filterComponents = [
            {
                type: 'searchable-dropdown',
                title: 'Subtransaction Type',
                values: this.bulkPayService.transactionTypes.map(function (t) { return t.displayName; }),
                key: 'subTransactionType'
            },
            {
                type: 'calendar',
                title: 'Created Date',
                key: 'createdAt'
            }
        ];
    }
    BulkPayHistoryComponent.prototype.showAlertBox = function (options, cb) {
        if (cb === void 0) { cb = function () { }; }
        this.alertService.open(options);
        this.alertService.confirmed().subscribe(function (confirmed) { return confirmed && cb(); });
    };
    BulkPayHistoryComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentRoute.queryParams
            .subscribe(function (params) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!params.downloadResult) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.downloadResultCSV(params.downloadResult)];
                    case 1:
                        _a.sent();
                        this.router.navigateByUrl(BULK_PAY_HISTORY);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.fetchHistory()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        ;
                        return [2 /*return*/];
                }
            });
        }); });
    };
    BulkPayHistoryComponent.prototype.fetchHistory = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, history_1, e_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loader.openLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.addPageDetails();
                        query = this.buildHistoryQuery();
                        return [4 /*yield*/, this.bulkPayService.fetchBulkPayHistory(query)];
                    case 2:
                        history_1 = _a.sent();
                        this.logUnknownSubTransactionTypes(history_1);
                        this.table.data = history_1.map(function (item) { return (tslib_1.__assign({}, item, { subTransactionType: _this.subTransactionTypeName(item.subTransactionType), createdAt: new Date(item.createdAt).toLocaleDateString(), result: new TableData({
                                type: TableDataTypes.BUTTON,
                                button: new Button({
                                    label: "Download Result",
                                    className: "btn btn-secondary",
                                    onClick: function () { return _this.downloadResultCSV(_this.fileId(item)); },
                                })
                            }) })); });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.table.data = [];
                        console.error("[BulkPayHistory] Failed to fetch history", e_1);
                        this.showAlertBox({
                            title: "Error",
                            message: "Something went wrong while fetching history",
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BulkPayHistoryComponent.prototype.downloadResultCSV = function (fileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, file_1, transactions, subTransactionType, formatArrayFields, e_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loader.openLoading();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.bulkPayService.downloadResult(fileId)];
                    case 2:
                        _a = _b.sent(), file_1 = _a.file, transactions = _a.transactions;
                        subTransactionType = this.bulkPayService.transactionTypes
                            .find(function (t) { return t.name === file_1.subTransactionType; });
                        if (!subTransactionType) {
                            console.error("[BulkPayHistory] Cannot download result, subTransactionType not in config", {
                                subTransactionType: file_1.subTransactionType,
                                fileId: fileId,
                                configuredTypes: this.bulkPayService.transactionTypes.map(function (t) { return t.name; }),
                            });
                            throw new Error("subTransactionType not found in config: " + file_1.subTransactionType);
                        }
                        formatArrayFields = function (transaction) {
                            return BulkPayArrayFields.reduce(function (item, field) {
                                var value = transaction[field];
                                if (!value) {
                                    return item;
                                }
                                item[field] = value.join("|");
                                return item;
                            }, transaction);
                        };
                        Utils.downloadCSVFile({
                            data: transactions.map(formatArrayFields),
                            fields: subTransactionType.headers.concat("status"),
                            fileName: (file_1.subTransactionType + "_" + file_1.createdAt + "_result.csv").toLowerCase()
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        e_2 = _b.sent();
                        console.error("[BulkPayHistory] Failed to download result", e_2);
                        this.showAlertBox({
                            title: "Error",
                            message: "Something went wrong while downloading result",
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BulkPayHistoryComponent.prototype.addPageDetails = function () {
        var limit = this.table.pagination.perPage;
        this.historyQuery.limit = limit;
        this.historyQuery.offset = this.table.pagination.pageNo * limit;
    };
    BulkPayHistoryComponent.prototype.buildHistoryQuery = function () {
        var query = {
            limit: this.historyQuery.limit,
            offset: this.historyQuery.offset,
            sortBy: this.historyQuery.sortBy,
            sortOrder: this.historyQuery.sortOrder,
        };
        if (this.historyQuery.subTransactionType.length > 0) {
            query.subTransactionType = this.historyQuery.subTransactionType;
        }
        if (this.historyQuery.from) {
            query.from = this.historyQuery.from;
        }
        if (this.historyQuery.to) {
            query.to = this.historyQuery.to;
        }
        return query;
    };
    BulkPayHistoryComponent.prototype.fileId = function (item) {
        if (typeof item._id === "string") {
            return item._id;
        }
        return item._id && item._id.$oid;
    };
    BulkPayHistoryComponent.prototype.logUnknownSubTransactionTypes = function (history) {
        var _this = this;
        var configuredTypes = new Set(this.bulkPayService.transactionTypes.map(function (t) { return t.name; }));
        var unknownRecords = history.filter(function (item) { return !configuredTypes.has(item.subTransactionType); });
        if (unknownRecords.length === 0) {
            return;
        }
        var unknownTypes = Array.from(new Set(unknownRecords.map(function (item) { return item.subTransactionType; })));
        console.error("[BulkPayHistory] Unknown subTransactionType(s) in history response", {
            unknownTypes: unknownTypes,
            fileIds: unknownRecords.map(function (item) { return _this.fileId(item); }),
            configuredTypes: Array.from(configuredTypes),
        });
    };
    BulkPayHistoryComponent.prototype.subTransactionTypeName = function (code) {
        var match = this.bulkPayService.transactionTypes.find(function (t) { return t.name === code; });
        if (!match) {
            console.error("[BulkPayHistory] subTransactionType not found in config", {
                subTransactionType: code,
                configuredTypes: this.bulkPayService.transactionTypes.map(function (t) { return t.name; }),
            });
            return code;
        }
        return match.displayName;
    };
    BulkPayHistoryComponent.prototype.subTransactionTypeCode = function (name) {
        var match = this.bulkPayService.transactionTypes.find(function (t) { return t.displayName === name; });
        if (!match) {
            console.error("[BulkPayHistory] subTransactionType filter not found in config", {
                displayName: name,
                configuredTypes: this.bulkPayService.transactionTypes.map(function (t) { return t.name; }),
            });
            return name;
        }
        return match.name;
    };
    BulkPayHistoryComponent.prototype.sortByHeader = function (header) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var sortOrder, column;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sortOrder = header.includes("-") ? -1 : 1;
                        column = header.replace("-", "");
                        if (!this.sortableColumns.includes(column)) {
                            return [2 /*return*/];
                        }
                        this.historyQuery.sortBy = column;
                        this.historyQuery.sortOrder = sortOrder;
                        return [4 /*yield*/, this.fetchHistory()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BulkPayHistoryComponent.prototype.applyFilters = function (newFilters) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, from, to;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (newFilters.subTransactionType && newFilters.subTransactionType.length > 0) {
                            this.historyQuery.subTransactionType = newFilters
                                .subTransactionType
                                .map(function (name) { return _this.subTransactionTypeCode(name); });
                        }
                        else {
                            this.historyQuery.subTransactionType = [];
                        }
                        _a = newFilters.createdAt || [], from = _a[0], to = _a[1];
                        this.historyQuery.from = from ? moment(from).valueOf() : undefined;
                        this.historyQuery.to = to ? moment(to).endOf("day").valueOf() : undefined;
                        return [4 /*yield*/, this.fetchHistory()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BulkPayHistoryComponent;
}());
export { BulkPayHistoryComponent };
